import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getSliders } from "../Service/Api";

function HomeSlider() {
  var settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 8000,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const sliderData = await getSliders();
      setData(sliderData);
    };
    fetchData();
  }, []);

  const emptyArray = [
    { attachment: "slide1.jpg"},
    { attachment: "slide2.jpg"},
  
  ];

  return (
    <div class="slider">
      <div className="slider-container">
        <Slider {...settings}>
          {data[0]?.attachments.length > 0 ? 
            data[0]?.attachments.map((item, index) => (
              <div key={index}>
                <img src={`https://webapi.entab.info/api/image?url=${item.attachment}`} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />       
              </div>
            )) : 
            emptyArray.map((item, index) => (
              <div key={index}>
                <img src={item.attachment} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />       
              </div>
            ))
          }
        </Slider>
      </div>
    </div>
  );
}

export default HomeSlider;
